var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-12 houses-component-container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "div",
          { staticClass: "house-component-row" },
          [
            _vm._l(_vm.houses, function(house, index) {
              return _c("house-list-item", {
                key: house.id,
                attrs: { houseId: house.id, index: index }
              })
            }),
            _vm._v(" "),
            _c("div", { staticClass: "house-component--new" }, [
              _c(
                "div",
                {
                  staticClass:
                    "house-component-inner--new js-houses-component-eq-height"
                },
                [
                  _c(
                    "div",
                    { staticClass: "house-component--new-inputs" },
                    [
                      _vm.canAddHouses
                        ? [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.showModal()
                                  }
                                }
                              },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "add-house-link",
                                    attrs: { href: "#" }
                                  },
                                  [_vm._v("Nytt hus")]
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "modal",
                        {
                          attrs: {
                            name: "add-house-modal",
                            width: 750,
                            height: 760,
                            draggable: "true"
                          }
                        },
                        [
                          _vm.isBasedOnCustomReferenceHouses
                            ? _c(
                                "div",
                                [
                                  _c("custom-reference-house", {
                                    attrs: {
                                      onCancel: _vm.hideModal,
                                      onOk: _vm.addCustomRefHouse
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-sm-12" }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "add-house-modal-heading"
                                      },
                                      [_vm._v("Välj referenshus")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-sm-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "add-house-modal-filter" },
                                      [_c("reference-house-filter")],
                                      1
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [_c("carousel")],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "row top-buffer modal-actions"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-6 text-left" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                _vm.hideModal()
                                              }
                                            }
                                          },
                                          [_vm._v("Avbryt")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-6 text-right" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                _vm.addNewHouse()
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "spinner" },
                                              [_vm._v("Använd detta hus")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                        ]
                      )
                    ],
                    2
                  )
                ]
              )
            ])
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn--round house-component-add",
        attrs: { type: "button" }
      },
      [_c("span", { staticClass: "spinner glyphicon glyphicon-plus" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/houseList.vue?vue&type=template&id=61e55e84&
// module id = 501
// module chunks = 0